module.exports = __webpack_public_path__ + "img/joywork-app.c2c61d1d.png";